// extracted by mini-css-extract-plugin
export default {"popoverContent":"NavBarMenu_popoverContent__nnSQ9","popoverFooter":"NavBarMenu_popoverFooter__iCrxk"};